import { atomWithSessionStorage } from "@/utils/jotai/atomStorage.ts";

/**
 * Track if the user has dismissed the welcome modal. (`number` for backward compatibility)
 *
 * Session storage so that it will eventually be displayed again.
 */
export const welcomeSeenAtom = atomWithSessionStorage<number | undefined>("firstAccount", undefined);
